import React from "react";
import BreadCrumb from "../../../../../components/organisms/Breadcrumb/BreadCrumb";
import Headline from "../../../../../components/organisms/Headline/Headline";

const LeadHeader = () => (
  <>
    <BreadCrumb />
    {/* <Headline name="Lead details" subHeading="Smarter lead management for better conversions"/> */}
  </>
);

export default LeadHeader;
